export default "__VITE_ASSET__fab6a485__"